import fetch from '@/utils/fetch.js'
import {shop_url} from '@/global';

const getCoupon = (data) => {
    return fetch({
        url: `${shop_url}/shop/cms/coupon/list`,
        method: "post",
        data
    })
}

const getMch = () => {
    return fetch({
        url:`${shop_url}/shop/cms/mchs/all`,
        method:'get'
    })
}

const addCoupon = (data) => {
    return fetch({
        url:`${shop_url}/shop/cms/coupon/web`,
        method:'post',
        data
    })
}

const closeCoupon = (id) => {
    return fetch({
        url:`${shop_url}/shop/cms/coupon/status/${id}`,
        method:'put'
    })
}
export {
    getCoupon,
    getMch,
    addCoupon,
    closeCoupon
}



// WEBPACK FOOTER //
// ./src/api/active/coupon.js